import Axios from "axios";
import type { EquipmentInventory } from "../../../../features/FloorManager/typings/svg.types";
import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";
import { isResourceOrderRequest } from "./resolveOrderRequestBookingType.function";

async function fetchEquipmentInventory(
  equipmentId: number,
  locationInventoryId: number | null | undefined
): Promise<EquipmentInventory | null> {
  if (locationInventoryId != null) {
    const { data } = await Axios.get<EquipmentInventory[]>("/equipment-inventory/filtered", {
      params: { type: "location", ids: [locationInventoryId] }
    });
    const match = data.find(item => item.id === equipmentId);
    if (match) {
      return match;
    }
  }

  const { data } = await Axios.get<EquipmentInventory[]>("/equipment-inventory");
  return data.find(item => item.id === equipmentId) ?? null;
}

export async function enrichResourceEquipmentDetail(
  data: DetailedServiceBookingData
): Promise<DetailedServiceBookingData> {
  if (!isResourceOrderRequest(data) || data.resourceKind !== "equipment") {
    return data;
  }

  const equipmentId = data.bookingInventoryId ?? data.equipments[0]?.id;
  if (equipmentId == null) {
    return data;
  }

  try {
    const inventory = await fetchEquipmentInventory(equipmentId, data.locationInventoryId);
    if (!inventory) {
      return data;
    }

    const inventoryCost = inventory.pricePerHour ?? 0;
    const inventoryLeadTime = inventory.bookingLeadTime ?? 0;

    return {
      ...data,
      equipments: data.equipments.map(eq => ({
        ...eq,
        costPerHour: eq.costPerHour ?? inventoryCost,
        bookingLeadTime: eq.bookingLeadTime ?? inventoryLeadTime,
        description: eq.description || inventory.description || "",
        category: eq.category || inventory.equipmentCategory?.name || ""
      }))
    };
  } catch {
    return data;
  }
}
